import { CheckboxList } from "components/CheckboxList";
import { useValidate } from "formvalidation/hooks";
import React from "react";
import { Message } from "semantic-ui-react";
import { useTags } from "./hooks";

interface Props {
  mainArea: "company" | "contact" | "show"
  value: server.dto.TagSmall[]
  onChange: (tags: server.dto.TagSmall[]) => void
  inPageEditing: "new" | "edit" | "none"
}

const TagsSelect = (props: Props) => {
  const tagsQuery = useTags(props.mainArea);
  const maxAssignedTagCount = serverReference.constants[props.mainArea].maxAssignedTagCount;

  const validation = useValidate<HTMLDivElement, server.dto.TagSmall[]>({
    key: "tags",
    title: RESX.Tag.Tags,
    value: props.value,
    validate: async value => value.length <= maxAssignedTagCount
      ? true
      : RESX.GeneralWarnings.YouCanSelectAMaximumOfXItems.replace("{0}", maxAssignedTagCount.toString())
  });

  const onChange = (selected: server.dto.TagSmall[]) => {
    props.onChange([...selected].sort((a, b) => a.tagId - b.tagId));
  };

  return <div ref={validation.ref}>
    <CheckboxList
      options={tagsQuery.data ?? []}
      getId={tag => tag.tagId}
      getLabel={tag => tag.title}
      value={props.value}
      onChange={onChange}
      multipleColumns={true}
      inPageEditing={props.inPageEditing}
      keyboardNavigationGroup="tagSelect"
      isLoading={tagsQuery.isLoading}
    />
    {validation.error.hasError && <Message color="red">{validation.error.errorMessage}</Message>}
  </div>;
};

export default TagsSelect;
